import { DynamicScroller } from 'vue-virtual-scroller';
import WidgetArticleRow from './WidgetArticleRow';
import WidgetFolderRow from './WidgetFolderRow';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import {ARTICLE_TYPE} from "@/utils/constants";

export default {
	name: 'WidgetContentItemsList',
	watch: {
		contentItems: {
			handler() {
				this.scrollToCurrentArticle();
			},
			immediate: true,
		},
		resetScrollOnce(v) {
			if (v) {
				this.scrollOnce = true;
			}
		}
	},
	methods: {
		scrollToCurrentArticle() {

			if (!this.scrollOnce) {
				return;
			}

			clearTimeout(this.idScrollToCurrentArticle);
			this.idScrollToCurrentArticle = setTimeout(() => {
				const index = this.contentItems.findIndex(item => item.id === this.articleId && item.type === ARTICLE_TYPE);
				if (index >= 0 && this.$refs?.widgetContentItems) {
					this.$refs.widgetContentItems.scrollToItem(index);
					this.scrollOnce = false;
				}
			}, 100);
		}
	},
	props: {
		contentItems: {
			type: Array,
			default() { return []; }
		},
		projectId: {
			type: Number,
			default: 0
		},
		articleId: {
			type: Number,
			default: 0
		},
		resetScrollOnce: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			idScrollToCurrentArticle: 0,
			scrollOnce: true
		}
	},
	render(createElement) {
		return createElement(DynamicScroller, {
			class: 'content-items custom-scroll',
			ref: 'widgetContentItems',
			props: {
				items: this.contentItems,
				itemSize: 30,
				minItemSize: 30,
				keyField: 'contentItemId',
			},
			scopedSlots: {
				default: ({item}) => {
					let template = item.type === ARTICLE_TYPE ? WidgetArticleRow : WidgetFolderRow;
					return createElement(template, {
						key: item.contentItemId,
						props: {
							contentItem: item,
							articleId: this.articleId,
							projectId: this.projectId
						},
					});
				},
			},
		});
	}
}
